import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IFetchRoomResponse, IRoomDetails } from 'src/app/models/dashboard.models';
import { ChatService } from 'src/app/services/chat.service';

@Component({
  selector: 'app-chat-list',
  templateUrl: './chat-list.component.html',
  styleUrls: ['./chat-list.component.scss']
})
export class ChatListComponent implements OnInit {

  selected: number;
  chatList: Array<IRoomDetails> = [];
  @Output() selectedChat = new EventEmitter();
  chatIndex: string = '';
  loading: boolean = true;

  constructor(public chatService: ChatService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.getChatList();
  }

  getChatList(){
    this.route.queryParams
      .subscribe(params => {
        this.chatIndex = params.roomId ? params.roomId : '';
      }
    );

    this.chatService.fetchChatRooms()
    .subscribe((res: IFetchRoomResponse)=>{
      this.chatList = res.payload;
      console.log("Fetch Rooms:", this.chatList);
      this.loading = false;
      if(this.chatIndex.length){
        this.chatList.forEach((chat, index)=>{
          if(chat.roomId == this.chatIndex)
          {
            this.selectChat(index);
          }
        })
      }
      else{
        this.selectChat(0);
      }
      this.fetchLastMessages();
    },err=>{
      this.loading = false;
      console.error("Fetch Rooms Error:", err);
    });
  }

  selectChat(index: number){
    this.selected = index;
    this.selectedChat.emit(this.chatList[index]);
  }

  fetchLastMessages(){
    this.chatList.forEach(chat => {
      this.chatService.getLastMessage(chat.roomId).subscribe(res=>{
        if(res.length){
          chat.lastMessage = res[0].message;
          chat.timestamp = new Date(res[0].timestamp);
        }
      });
    });
  }

}
